const REQUEST_TRANSFER_MODULE = 'transfer';

const PAGES_PATH = {
  SignIn: 'sign-in',
  Verify: 'startend',
  SelectEvent: 'select-event',
  ItemCountDetail: 'product-count',
  RequestTransferList: REQUEST_TRANSFER_MODULE,
  RequestTransferAdd: `${REQUEST_TRANSFER_MODULE}/add`,
  Success: 'success',
  Error: 'error',
};

export { REQUEST_TRANSFER_MODULE, PAGES_PATH };
